import { render, staticRenderFns } from "./FeedbackSuccess.vue?vue&type=template&id=25c52b9b&scoped=true"
import script from "./FeedbackSuccess.vue?vue&type=script&lang=js"
export * from "./FeedbackSuccess.vue?vue&type=script&lang=js"
import style0 from "./FeedbackSuccess.vue?vue&type=style&index=0&id=25c52b9b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c52b9b",
  null
  
)

export default component.exports